import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SnpDetailComponent } from './snp-detail/snp-detail.component';
import { ConcordanceGraphComponent } from './concordance-graph/concordance-graph.component';
import { ProbeGraphComponent } from './probe-graph/probe-graph.component';
import { SnpListComponent } from './snp-list/snp-list.component';
import { ConfigComponent } from './config/config.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { UserGuard } from './user.guard';
import { ErrorComponent } from './error/error.component';

const routes: Routes = [
  { path: 'concordance', component: ConcordanceGraphComponent, canActivate: [AuthGuard]},
  { path: 'config', component: ConfigComponent, canActivate: [AuthGuard] },
  { path: 'probes', component: ProbeGraphComponent, canActivate: [AuthGuard] },
  { path: 'detail/:id', component: SnpDetailComponent, canActivate: [AuthGuard] },
  { path: 'list', component: SnpListComponent, canActivate: [AuthGuard] },
  { path: 'error', component: ErrorComponent },
  { path: '', component: HomeComponent },
  //{ path: '', redirectTo: 'config', pathMatch: 'full' },
  { path: '**', redirectTo: 'config' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
